import React from 'react';
import './StockWarningMessage.scss';
import { STOCK_STATUS_ENUM, type IStockStatusProps } from '../helpers/storeConfirmSizes.types';

interface IStockWarningMessageProps {
  stockProps: IStockStatusProps;
}

const getStatusClassName = (
  status: IStockStatusProps['status'],
  isOutOfStock: boolean,
  isLowStock: boolean
): string => {
  if (isOutOfStock) {
    return 'stock-warning-message--out-of-stock';
  }
  if (isLowStock) {
    return 'stock-warning-message--low-stock';
  }
  if (status === STOCK_STATUS_ENUM.STOCK_DATA_UNAVAILABLE) {
    return 'stock-warning-message--out-of-stock';
  }
  return 'stock-warning-message--out-of-stock';
};

const StockWarningMessage: React.FC<IStockWarningMessageProps> = ({ stockProps }) => {
  const {
    status,
    checkoutMessage,
    message,
    showOpsApprovalMessage,
    opsApprovalMessage,
    backgroundColor,
    borderColor,
    fontColor,
    iconColor,
  } = stockProps;

  const displayMessage = checkoutMessage || message;
  if (!displayMessage) return null;

  const isOutOfStock =
    status === STOCK_STATUS_ENUM.OUT_OF_STOCK || status === STOCK_STATUS_ENUM.LOW_AND_OUT_OF_STOCK;
  const isLowStock =
    status === STOCK_STATUS_ENUM.LOW_IN_STOCK || status === STOCK_STATUS_ENUM.IN_STOCK;

  const statusClass = getStatusClassName(status, isOutOfStock, isLowStock);

  return (
    <div className="stock-warning-message">
      <div className={`stock-warning-message__status ${statusClass}`} style={{ borderColor }}>
        <div className="stock-warning-message__main" style={{ backgroundColor }}>
          <div className="stock-warning-message__text" style={{ color: fontColor }}>
            <span className="stock-warning-message__icon" style={{ color: iconColor }}>
              ⚠
            </span>
            <span className="stock-warning-message__message">{displayMessage}</span>
          </div>
        </div>
        {showOpsApprovalMessage && opsApprovalMessage && (
          <div
            className="stock-warning-message__ops"
            style={{ borderTop: `1px dashed ${borderColor}` }}
          >
            {opsApprovalMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default StockWarningMessage;
